module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/13f7d9eda10cb6bb16b313ec8d90b3a8.png";